import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { TradeClassDirective } from '../../../multisite/trade/trade-class.directive';
import { AbstractPageFooterColumnComponent } from './abstract-page-footer-column.component';
import { IPageFooterColumn } from './page-footer.component';
@Component({
    selector: 'page-footer-column',
    templateUrl: 'page-footer-column.html',
    standalone: true,
    imports: [TradeClassDirective, ICmsClientModule, HrefComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageFooterColumnComponent extends AbstractPageFooterColumnComponent {
    @Input({
        required: true
    })
    override column!: IPageFooterColumn;
    @Input()
    isFirst: boolean = false;
    @Input()
    isLast: boolean = false;
}
